<template>
  <div id="app">
    <div id="pano"></div>
    <!-- <button id="play" @click="play"></button> -->
    <!-- <img src="./logo.png" class="logo" /> -->
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      krpano: null,
      totaltime:null,
      date_start:null,
    };
  },
  mounted() {
    var that = this;
    this.date_start=new Date("2020-08-20 14:50:00").getTime();
    this.Utils.loadScript("https://res.mp.oeeee.com/h5static/v20/source_sz/krpano/krpano.js").then(() => {
      embedpano({
        swf: "krpano.swf",
        xml: "https://res.mp.oeeee.com/h5static/v20/source_sz/krpano/videopano_zzj.xml?v="+new Date().getTime(),
        target: "pano",
        html5: "auto",
        id: "krpanoSWFObject",
        html5preload: true,
        mobilescale: 1.0,
        passQueryParameters: true,
        onready: krpanoReady,
      });
      function krpanoReady(krpano) {
        that.krpano = krpano;
      }
    });
    this.setShareInfo();
  },
  methods: {
    play() {
        // this.krpano.call()
        // var that=this;
        // this.krpano.call("layer[skin_video_playpause].onclick()");
        // var date_cur=new Date().getTime();
        // var dis=(date_cur-this.date_start)/1000;
        // 需要改videointerface文件相关属性visible="false"
        // setTimeout(()=>{
        //   that.totaltime=that.krpano.get("plugin[video].totaltime");
        //   if(dis>0&&dis<that.totaltime){
        //     that.krpano.call("plugin[video].seek("+dis+");");
        //   }else{
        //     that.krpano.set('layer[skin_video_time].visible',true);
        //     that.krpano.set('layer[skin_video_seekbar_container].visible',true);
        //   }    
        // },1000)
    },
    //设置分享
    setShareInfo(data) {
      this.Weixin.ready({
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
        ],
      }).then(() => {
        this.Weixin.share({
          imgUrl:
            "http://res.mp.oeeee.com/h5static/v20/source_sz/images/share_zzj.png",
          desc: "南都VR全景视频，超凡视角纵览深圳。",
        });
      });
    },
  },
};
</script>

<style type="text/less" lang="less">
#app,
#pano {
  position: relative;
  width: 100%;
  height: 100%;
}
// .logo {
//   position: absolute;
//   top: 20px;
//   left: 20px;
//   width: 220px;
//   height: 150px;
// }
#play{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 220px;
  height: 150px;
  opacity: 0;
}
</style>
